import { inject } from 'aurelia-framework';
import tippy from 'tippy.js';

@inject(Element)
export class TipCustomAttribute {
    constructor(element) {
        this.element = element;
    }

    bind() {
        tippy(this.element, {
            content: this.value,
            allowHTML: true
        });
    }
}